import { render } from "./FormAlertsComponent.vue?vue&type=template&id=13005430&scoped=true"
import script from "./FormAlertsComponent.vue?vue&type=script&lang=js"
export * from "./FormAlertsComponent.vue?vue&type=script&lang=js"

import "./FormAlertsComponent.vue?vue&type=style&index=0&id=13005430&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13005430"]])

export default __exports__